export const GuestCountIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.31765 1.66602C6.13431 1.66602 4.35931 3.44102 4.35931 5.62435C4.35931 7.76602 6.03431 9.49935 8.21765 9.57435C8.28431 9.56602 8.35098 9.56602 8.40098 9.57435C8.41765 9.57435 8.42598 9.57435 8.44265 9.57435C8.45098 9.57435 8.45098 9.57435 8.45931 9.57435C10.5926 9.49935 12.2676 7.76602 12.276 5.62435C12.276 3.44102 10.501 1.66602 8.31765 1.66602Z"
        fill="#565656"
      />
      <path
        d="M12.551 11.7914C10.226 10.2414 6.43431 10.2414 4.09264 11.7914C3.03431 12.4997 2.45097 13.4581 2.45097 14.4831C2.45097 15.5081 3.03431 16.4581 4.08431 17.1581C5.25097 17.9414 6.78431 18.3331 8.31764 18.3331C9.85097 18.3331 11.3843 17.9414 12.551 17.1581C13.601 16.4497 14.1843 15.4997 14.1843 14.4664C14.176 13.4414 13.601 12.4914 12.551 11.7914Z"
        fill="#565656"
      />
      <path
        d="M17.476 6.11708C17.6093 7.73374 16.4593 9.15041 14.8676 9.34208C14.8593 9.34208 14.8593 9.34208 14.851 9.34208H14.826C14.776 9.34208 14.726 9.34208 14.6843 9.35874C13.876 9.40041 13.1343 9.14208 12.576 8.66708C13.4343 7.90041 13.926 6.75041 13.826 5.50041C13.7676 4.82541 13.5343 4.20874 13.1843 3.68374C13.501 3.52541 13.8676 3.42541 14.2426 3.39208C15.876 3.25041 17.3343 4.46708 17.476 6.11708Z"
        fill="#565656"
      />
      <path
        d="M19.1426 13.8247C19.076 14.633 18.5593 15.333 17.6926 15.808C16.8593 16.2663 15.8093 16.483 14.7676 16.458C15.3676 15.9163 15.7176 15.2413 15.7843 14.5247C15.8676 13.4913 15.376 12.4997 14.3927 11.708C13.8343 11.2663 13.1843 10.9163 12.476 10.658C14.3176 10.1247 16.6343 10.483 18.0593 11.633C18.826 12.2497 19.2176 13.0247 19.1426 13.8247Z"
        fill="#565656"
      />
    </svg>
  );
};
